module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_01-6d83eb04b117e7ad7e72046748fd8f31.jpg";